import { render, staticRenderFns } from "./BlogPostCard.vue?vue&type=template&id=d884b422&"
import script from "./BlogPostCard.vue?vue&type=script&lang=js&"
export * from "./BlogPostCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports